import { SpatialLayer } from '@innovyze/lib-am-common';
import { createAction } from '@reduxjs/toolkit';

export const changeSpatialProximity = createAction<SpatialLayer | undefined>(
	'spatialProximity/changeDataSource',
);
